import type { ReactNode } from "react";

interface EmptyStateProps {
  title: string;
  message?: string;
  action?: ReactNode;
}

export function EmptyState({ title, message, action }: EmptyStateProps) {
  return (
    <div className="state state--empty">
      <h2 className="state__title">{title}</h2>
      {message ? <p className="state__message">{message}</p> : null}
      {action ? <div className="state__actions">{action}</div> : null}
    </div>
  );
}
